<template>
  <div>
    <div class="slide-proportion-2-3">
      <div class="left-block-positioner">
        <h1 class="slide-header">ФАКТ 4</h1>
        <p class="tagline">
          У тюленів поганий зір, але все прекрасно зі слухом і вибором дизеля
          від ОККО, який не замерзає до мінус сорока.
        </p>
      </div>
    </div>
  </div>
</template>

<script>        
  export default {};
</script>

<style lang="scss" scoped>
  @import '~styles/scss/slide-fragment.scss';
</style>



// WEBPACK FOOTER //
// src/components/SlideFragment/Slides/Fact4/Left.vue